/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import type { Action, Location } from "history";
import { shallowEqual } from "react-redux";
import * as History from "../../../common-deprecated/History";
import { historyEvent } from "../../../common-deprecated/redux/actions/UtilActions";
import { useUscDispatch, useUscSelector } from "../redux/store";
import { setCheckoutType, setConfiguration } from "../redux/actions/UscBasketActions";
import { UscNavStepEnum } from "../utils/constants";
import { setupTrackingBaseLayerAem, trackStepLoad } from "../utils/tracking";
import { MODAL_USC_FORM } from "../../shared-logic/utils/integrated-modal/integratedModalConstants";
import { getUscBasketConfiguration, uscLocalStorageParamSelector } from "../utils/localStorage";

const useUsedStockCars = (): void => {
    const dispatch = useUscDispatch();
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const vehicleResult = useUscSelector((state) => state.vehicle.result);
    const step = useUscSelector((state) => state.nav.step);
    const dealer = useUscSelector((state) => state.dealer);
    const configuration = useUscSelector((state) => state.basket.configuration);
    const hasOpenedUscFormModal = useUscSelector((state) =>
        state.modal.modals.some((modal) => modal.settings?.type === MODAL_USC_FORM && modal.show),
    );
    const localStorageParams = useUscSelector(uscLocalStorageParamSelector, shallowEqual);
    // Reset checkoutType when the user is on the pdp.
    // At this point, they have yet to select a purchase type, but it's possible
    // to return to the pdp from customise, so we need to reset it.
    useEffect(() => {
        if (step === UscNavStepEnum.Pdp) {
            dispatch(setCheckoutType(null));
        }
    }, [step]);

    // listen for history state changes
    useEffect(() => {
        History.listen((location: Location, action: Action) => {
            dispatch(historyEvent(location, action));
        });
    }, []);

    // Set the basket configuration if present in local storage
    // and no configuration is present in the store
    useEffect(() => {
        if (configuration.accessories.length || configuration.packs.length) return;

        const foundConfiguration = getUscBasketConfiguration(localStorageParams, vehicleResult?.id || "");
        const configurationHasItems = foundConfiguration?.accessories.length || foundConfiguration?.packs.length;
        if (configurationHasItems) dispatch(setConfiguration(foundConfiguration));
    }, []);

    // ----------------------------------------------------------------------
    // Tracking
    // ----------------------------------------------------------------------

    useEffect(() => {
        if (
            vehicleResult &&
            (vehicleResult.dealerId ? dealer.initialized : true) && // Only check for dealer being initialized if the vehicle has an actual dealer.
            !hasOpenedUscFormModal // Every time the usc form modal closes the USC tracking base layer should be updated back to the PDP specific vehicle and dealer
        ) {
            setupTrackingBaseLayerAem(vehicleType, vehicleResult, dealer.dealer);
        }
    }, [vehicleResult, dealer, hasOpenedUscFormModal]);

    useEffect(() => {
        trackStepLoad(step, vehicleType);
    }, [step]);
};

export default useUsedStockCars;
